'use client';

import { vars } from '@/theme/vars.css';
import { AnimatePresence, motion } from 'framer-motion';
import SearchForm from '../SearchForm';
import Container from '../ui/Container';
import Flex from '../ui/Flex';
import * as styles from './NavBar.css';
import { useNavbarActions } from './useNavbarState';

const NavSearch = () => {
  const search = useNavbarActions((s) => s.search);

  return (
    <AnimatePresence>
      {search && (
        <Flex
          as={motion.div}
          colorSet="cream"
          paper
          justifyContent="center"
          className={styles.searchWrapper}
          initial={{ opacity: 0, x: 15 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0 }}>
          <Container>
            <SearchForm
              SearchBtnProps={{ color: 'black', variant: 'icon' }}
              CloseBtnProps={{ color: 'black', variant: 'text' }}
              TextFieldProps={{
                InputProps: {
                  disableUnderline: true,
                  sx: {
                    fontSize: vars.typography.size.h5,
                  },
                },
              }}
            />
          </Container>
        </Flex>
      )}
    </AnimatePresence>
  );
};

export default NavSearch;
